import script from "./TopicAbility.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicAbility.vue?vue&type=script&setup=true&lang=js"

import "./TopicAbility.vue?vue&type=style&index=0&id=619a6c76&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619a6c76"]])

export default __exports__